import { GTMEvent } from '@corratech/pylot-gtm/src/GTM'
import { itemHasKeys } from '@corratech/pylot-utils'

export interface AdditionalData {
    creative_name: string
    creative_slot: string
    promotion_id: string
    promotion_name: string
}

export type GTMProductData = {
    id: string
    name: string
    currency?: string
    discount?: number
    brand?: string
    category?: string
    price: number
    quantity?: number
    subscription_frequency?: string
}

const EVENT_NAME_MAP = {
    view: 'upsell_promotion_viewed',
    add: 'upsell_promotion_selected'
}

export const UpsellPromotionAdditionalData: AdditionalData = {
    creative_name: 'Up-Sell Products CO',
    creative_slot: 'up_sell_products_co_1',
    promotion_id: 'usp_co_1',
    promotion_name: 'Up-Sell Products CO Popup'
}

const mandatoryItemProps = ['id', 'name']

const isValidGTMProductItems = (items: unknown): items is GTMProductData[] => {
    if (!Array.isArray(items)) {
        return false
    }
    let result = true
    for (const item of items) {
        if (item && !itemHasKeys(item, mandatoryItemProps)) {
            result = false
        }
    }
    return result
}

export const pushUpsellPromotionView = (
    data: Record<string, unknown>,
    eventHistory: () => string[]
): GTMEvent => {
    const { upsell_products_view } = data
    const events = eventHistory()

    if (
        !isValidGTMProductItems(upsell_products_view) ||
        events[events.length - 1] !== 'addToCart'
    ) {
        console.info('Invalid GTM Cross-Sell Products Data')
        return { event: '' }
    }

    const mappedItems = upsell_products_view.map((item) => ({
        ...item,
        ...UpsellPromotionAdditionalData
    }))

    return {
        event: EVENT_NAME_MAP['view'],
        ...UpsellPromotionAdditionalData,
        ecommerce: {
            items: [mappedItems]
        },
        _clear: true
    }
}

export const pushUpsellPromotionSelected = (
    data: Record<string, unknown>
): GTMEvent => {
    const { upsell_products_add } = data

    if (!isValidGTMProductItems(upsell_products_add)) {
        console.info('Invalid GTM Cross-Sell Products Data')
        return { event: '' }
    }

    const mappedItems = upsell_products_add.map((item) => ({
        ...item,
        ...UpsellPromotionAdditionalData
    }))

    return {
        event: EVENT_NAME_MAP['add'],
        ...UpsellPromotionAdditionalData,
        ecommerce: {
            items: [mappedItems]
        },
        _clear: true
    }
}
